import { render } from "./announcementThree.vue?vue&type=template&id=fce9844e"
import script from "./announcementThree.vue?vue&type=script&lang=js"
export * from "./announcementThree.vue?vue&type=script&lang=js"

import "./announcementThree.vue?vue&type=style&index=0&id=fce9844e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__